import request from "./axiosConfig";

/**
 * 查询用户模拟填报信息（分页）
 */
export function getMockRecords(params) {
  return request({
    url: "/interface/collegeapplication/list",
    method: "get",
    params: params,
  });
}